import React from 'react';
import { LinkButton } from '@/components/Button';
import { ArrowRight, CheckCircle } from 'lucide-react';

const assetClasses = [
  'Private Credit',
  'Venture Capital',
  'Real Estate',
  'Hedge Funds',
  'Direct & Co-investments',
  'Thematic Portfolios',
];

const ValuePropositionSection = () => {
  return (
    <section className="py-20 md:py-28 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 gap-12">
          {/* Card 1: Asset Classes */}
          <div className="bg-white p-10 rounded-2xl border border-slate-200/80">
            <span className="inline-block bg-slate-100 text-slate-700 text-sm font-semibold px-4 py-1.5 rounded-full mb-6">
              Our Offerings
            </span>
            <h3 className="text-3xl md:text-4xl font-bold text-gray-900 mb-5">
              Diversify Across Premier Asset Classes
            </h3>
            <p className="text-lg text-slate-600 mb-8">
              Gain access to institutional-quality assets across private credit, venture capital, real estate, and more, all on one platform.
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-3 mb-10">
              {assetClasses.map((item, index) => (
                <div key={index} className="flex items-center space-x-3">
                  <CheckCircle className="w-5 h-5 text-emerald-500 flex-shrink-0" />
                  <span className="text-slate-700">{item}</span>
                </div>
              ))}
            </div>
            <LinkButton 
              to="/investments"
              variant="solid"
              className="group rounded-full px-6 py-3 font-semibold text-base"
            >
              <span>View All Investments</span>
              <ArrowRight className="w-4 h-4 ml-2 transition-transform duration-300 group-hover:translate-x-1" />
            </LinkButton>
          </div>

          {/* Card 2: Due Diligence */}
          <div className="bg-white p-10 rounded-2xl border border-slate-200/80">
            <span className="inline-block bg-slate-100 text-slate-700 text-sm font-semibold px-4 py-1.5 rounded-full mb-6">
              Our Advantage
            </span>
            <h3 className="text-3xl md:text-4xl font-bold text-gray-900 mb-5">
              Institutional-Grade Due Diligence
            </h3>
            <p className="text-lg text-slate-600 mb-8">
              Our investment team is highly selective. Only a small fraction of opportunities pass our institutional-grade due diligence process, ensuring you only see the best.
            </p>
            <div className="bg-slate-50/80 p-8 rounded-xl border border-slate-200/80">
              <div className="text-5xl font-bold text-[hsl(var(--navy))] mb-2">
                &lt;10%
              </div>
              <p className="text-slate-600">
                Of reviewed deals make it onto the ALTA-X platform.
              </p>
            </div>
            <div className="mt-10">
              <LinkButton 
                to="/how-it-works"
                variant="solid"
                className="group rounded-full px-6 py-3 font-semibold text-base"
              >
                <span>Learn about our process</span>
                <ArrowRight className="w-4 h-4 ml-2 transition-transform duration-300 group-hover:translate-x-1" />
              </LinkButton>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ValuePropositionSection;
